import React, { Component } from 'react';
import { connect } from 'react-redux';
import ResizeObserver from 'resize-observer-polyfill';

import { RESOLUTIONS } from 'services/config';
import { confirmNewPassword, resetRegistrationState } from 'actions/registration';
/** v3 imports */
import { PasswordContainer } from '../../styled_components/Login/PasswordContainer';

const CDN_URL = process.env.REACT_APP_CDN_URL;
const dcbloxLogo = `${CDN_URL}common/dcblox-logo-lg.svg`;

class PasswordRegistrationNew extends Component {
	constructor(props) {
		super(props);

		this.timer = null;
		this.state = {
			alert: null,

			breakpoint: RESOLUTIONS.MED,
			enabled: true,

			enabled: true,

			email: '',
		};
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}
	onBreakpointChange = breakpoint => {
		let rowHeight = 0;
		let margin;
		let containerPadding;

		switch (breakpoint) {
			case 'xs':
				rowHeight = 15;
				margin = [21, 0];
				containerPadding = [90, 0];
				break;
			case 'sm':
				rowHeight = 18;
				margin = [21, 0];
				containerPadding = [95, 0];
				break;
			case 'md':
				rowHeight = 21;
				margin = [22, 0];
				containerPadding = [120, 0];
				break;
			case 'lg':
				rowHeight = 24;
				margin = [32, 0];
				containerPadding = [160, 0];
				break;
			default:
				rowHeight = 23;
				margin = [22, 0];
				containerPadding = [30, 0];
				break;
		}

		this.setState({ rowHeight, margin, containerPadding });
	};

	componentDidMount() {
		this.onBreakpointChange();

		this.screenObserver = new ResizeObserver(entries => {
			entries.forEach(entry => {
				const screenWidth = entry.contentRect.width;
				const screenHeight = entry.contentRect.height;
				this.updateScreenBreakpoint(screenWidth, screenHeight);
			});
		});
		const htmlEl = document.querySelector('html');
		this.screenObserver.observe(htmlEl);
	}

	updateScreenBreakpoint = (screenWidth, screenHeight) => {
		let breakpoint = RESOLUTIONS.MED;

		if (screenWidth > RESOLUTIONS.LOW && screenWidth <= RESOLUTIONS.MED) {
			breakpoint = RESOLUTIONS.LOW;
		} else if (screenWidth > RESOLUTIONS.MED && screenWidth <= RESOLUTIONS.HIGH) {
			breakpoint = RESOLUTIONS.MED;
		} else if (screenWidth > RESOLUTIONS.HIGH) {
			breakpoint = RESOLUTIONS.HIGH;
		} else {
			breakpoint = RESOLUTIONS.MIN;
		}
		this.setState({ breakpoint, screenWidth, screenHeight });
	};

	receiveInput = (password, confirmPassword) => {
		const { confirmNewPassword } = this.props;
		const { location } = this.props;
		const matches = location?.pathname.split('/');
		let code = '';
		if (matches) {
			const [, , key] = matches;
			code = key;
		}

		confirmNewPassword(confirmPassword, password, code);
	};
	updateMFAoption = value => {
		this.setState({ mfaOption: value, mfaRequestType: 'SUBMIT CODE' });
	};
	setMFACode = e => {
		this.setState({ code: e.target.value });
	};

	render() {
		const { auth_status, navigate, registration_status } = this.props;

		return (
			<div className='login login-section'>
				<div className='logo'>
					<img src={dcbloxLogo} />
				</div>
				<PasswordContainer
					receiveInput={this.receiveInput}
					auth_status={auth_status}
					navigate={navigate}
					registration_status={registration_status}
					resetRegistrationState={resetRegistrationState}
				/>
				<div key='forgot-password' className='forgot-password'>
					<>
						<div data-cy='forgot-your-password' className='forgot-password-link password'>
							Want to change your password ? Enter your new password a couple of times and we’ll get
							it changed for you.
						</div>
					</>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth_status: state.auth_status,
		registration_status: state.registration_status,
	};
}

export default connect(mapStateToProps, {
	confirmNewPassword,
	resetRegistrationState,
})(PasswordRegistrationNew);
